var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancelPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 74,
    viewBox: "0 0 58 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4ysr8xnkta",
    d: "M0 0.686L56.933 0.686 56.933 72.291 0 72.291z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.885) translate(0 .023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7tcpr5j15b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4ysr8xnkta"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M46.477 48.6C34.311 67.203 16.371 76.86 6.43 70.17c-9.951-6.68-8.155-27.189 4.024-45.792C22.63 5.783 40.562-3.882 50.503 2.806c9.952 6.683 8.155 27.188-4.026 45.795",
    mask: "url(#7tcpr5j15b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#11110F",
    d: "M25.51 37.135c0 1.848-1.496 3.349-3.343 3.349-1.845 0-3.345-1.5-3.345-3.349 0-1.847 1.5-3.345 3.345-3.345 1.847 0 3.344 1.498 3.344 3.345",
    transform: "translate(.885)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M41.432 45.612H16.814c-.583 0-1.058-.475-1.058-1.055v-13.23h26.732v13.23c0 .58-.476 1.055-1.056 1.055m-24.618-20.02h3.479c.066.55.516.985 1.086.985.57 0 1.02-.434 1.087-.985h13.35c.067.55.518.985 1.086.985.57 0 1.022-.434 1.09-.985h3.44c.58 0 1.056.474 1.056 1.057v2.422H15.756V26.65c0-.583.475-1.057 1.058-1.057m24.618-2.227h-3.415v-1.103c0-.615-.499-1.116-1.115-1.116-.614 0-1.112.501-1.112 1.116v1.103H22.492v-1.103c0-.615-.498-1.116-1.113-1.116-.614 0-1.112.501-1.112 1.116v1.103h-3.453c-1.81 0-3.283 1.473-3.283 3.284v17.908c0 1.808 1.472 3.283 3.283 3.283h24.618c1.81 0 3.283-1.475 3.283-3.283V26.649c0-1.81-1.473-3.284-3.283-3.284",
    transform: "translate(.885)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M30.825 32.796l.095.083 2.959 2.959 2.959-2.959c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.095-2.96 2.958 2.96 2.96c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083-2.96-2.959-2.958 2.96c-.39.39-1.024.39-1.415 0-.36-.361-.388-.929-.083-1.32l.083-.095 2.959-2.96-2.959-2.958c-.39-.39-.39-1.024 0-1.415.33-.33.835-.38 1.219-.152l.101.07z",
    transform: "translate(.885)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelPending);
export default __webpack_public_path__ + "static/media/icon_cancel_pending.f8f5114d67bc799136fd126feb689edd.svg";
export { ForwardRef as ReactComponent };